module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/ranking01-8c1581fd8f7d33d007ddc25b27b4dcb3.png";